<template>
    <div class="el-table-container templateBox">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1,1,1)" label-width="80px">
            <el-form-item label="渠道名称" prop="channelName">
                <el-input v-model.trim="searchForm.channelName" maxlength="50" placeholder="请输入渠道名称"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="创建人" prop="createBy">
                <el-select v-model="searchForm.createBy" clearable placeholder="请选择创建人" style="width: 100%">
                    <el-option
                        v-for="item in createByList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="创建时间" prop="createTime">
                <el-date-picker
                        v-model="searchForm.createTime"
                        clearable
                        style="width: 100%"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1,1,1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
            <el-form-item class="f_r">
                <el-button v-if="hasPermission('dyygRelease:column:channelList:add')" type="primary" @click="addColumn(0)"
                           size="small">新增
                </el-button>
                <el-button v-if="hasPermission('dyygRelease:column:channelList:deleteColumn')" type="primary"
                           @click="deleteColumn()" size="small">删除
                </el-button>
            </el-form-item>
        </el-form>
        <div class="dataBox">
            <el-table
                    :data="dataList"
                    v-loading="loading"
                    size="small" height="100%"
                    class="table" border
                    ref="multipleTable"
                    :row-key="'id'"
                    @sort-change="sortChange"
                    @selection-change="selectionChangeHandle"
            >
                <el-table-column :reserve-selection="true" type="selection" width="50"/>
                <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="channelName" label="渠道名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="sort" label="排序" sortable="custom" show-overflow-tooltip></el-table-column>
                <el-table-column prop="status" width="100px" label="显示状态" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <el-switch
                            v-model="row.status"
                            active-value="0"
                            @change="setType(row)"
                            inactive-value="1">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="createByName" label="创建人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="创建时间" sortable="custom" show-overflow-tooltip></el-table-column>
                <el-table-column prop="updateByName" label="最新修改人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="updateTime" label="最新修改时间" sortable="custom" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" label="操作">
                    <template slot-scope="{row}">
                        <el-button v-if="hasPermission('dyygRelease:column:channelList:edit')" type="text" size="small"
                                   @click="addColumn(2,row)">修改
                        </el-button>
                        <el-button v-if="hasPermission('dyygRelease:column:channelList:deleteColumn')" type="text"
                                   size="small" @click="deleteColumn(row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <add-channel ref="addChannel" @refresh="refreshList(1,1,1)"></add-channel>
    </div>
</template>

<script>
import AddChannel from "@/views/modules/dyygRelease/channel/addChannel.vue";

export default {
    name: "channelList",
    components: {AddChannel},
    data() {
        return {
            searchForm: {
                channelName:'',
                createBy:'',
                createTime:[],
                beginTime:'',
                endTime:'',
                customSort:'',
                current: 1,
                size: 20,
            },
            total: 0,
            createByList:[],

            loading: false,
            dataList: [],
            dataListSelect: [],
        }
    },

    mounted() {
        this.refreshList()
        this.getOtherList()
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect,sort) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            if (sort) {
                this.$refs.multipleTable.clearSort()
                this.searchForm.customSort = ''
            }
            if (this.searchForm.createTime && this.searchForm.createTime.length != 0){
                this.searchForm.beginTime = this.searchForm.createTime[0]
                this.searchForm.endTime = this.searchForm.createTime[1]
            }else {
                this.searchForm.beginTime = ''
                this.searchForm.endTime = ''
            }
            this.loading = true
            this.$axios(this.api.dyygRelease.releasesChannelList, this.searchForm, 'post').then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        getOtherList () {
            this.$axios(this.api.user.getSysUserByName, {}).then(data => {
                if (data && data.status) {
                    this.createByList = data.data
                }
            })
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1,1)
        },

        // 列表排序
        sortChange(column, type) {
            this.searchForm.customSort = ''
            if (column.prop == 'createTime') {
                this.searchForm.customSort = 'create_time ' + (column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : ''))
            }
            if (column.prop == 'sort') {
                this.searchForm.customSort = 'sort ' + (column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : ''))
            }
            if (column.prop == 'updateTime') {
                this.searchForm.customSort = 'update_time ' + (column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : ''))
            }
            this.refreshList(1, 1)
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },

        //切换状态
        setType(row) {
            row.status = row.status == 1 ? 0 : 1 //
            this.$axios(this.api.dyygRelease.releasesChannelUpdateById, {
                id:row.id,
                channelName: row.channelName,
                sort: row.sort,
                columnStatus: row.columnStatus,
                status: row.status == 1 ? 0 : 1,
            }, 'put').then(data => {
                if (data && data.status) {
                    this.$message.success('状态修改成功')
                    this.refreshList()
                } else {
                    this.$message.error(data.msg)
                }
            })
        },

        //0新增/2编辑按钮
        addColumn(num,row){
            this.$refs.addChannel.init(row)
        },

        //删除栏目
        deleteColumn(row) {
            let list = row ? [row] : this.dataListSelect
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let statusTrueList = []
            let ids = list.map(item => {
                if (item.status == 0){
                    statusTrueList.push(item)
                }
                return item.id
            })
            if (statusTrueList.length != 0) {
                this.$message.warning('请先禁用后再删除！')
                return
            }
            this.$confirm(`您是否确认删除数据?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.dyygRelease.releasesChannelRemoveByIds, ids, 'post').then(data => {
                    if (data && data.status) {
                        this.$message.success('删除成功')
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },


    },
}
</script>

<style scoped>

</style>
